export const types = {
  ANTD_SET: "ANTD_SET",
};

export const setAntd = (value) => ({
  type: types.ANTD_SET,
  value,
});

export const initialState = {
  message: null,
  notification: null,
  modal: null,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.ANTD_SET:
      return {
        ...state,
        ...action.value,
      };
    default:
      return state;
  }
}

const actions = {
  setAntd,
};

export default actions;
